// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"88fd9e67","502":"f06d5c77","848":"3f83d6eb"}[chunkId] + ".chunk.css";
};